import React, { Component } from "react";
import _ from "lodash";
import { Row, Col, Form } from "reactstrap";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class WallCalendar extends Component {
  onChange(item) {
    var wallCalendarIndex = _.findIndex(
      this.props.filterState.filterData.wallCalendar,
      (o) => {
        return o.id === item.id;
      }
    );
    item.checked = !this.props.filterState.filterData.wallCalendar[
      wallCalendarIndex
    ].checked;
    this.props.filterState.filterData.wallCalendar[wallCalendarIndex] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData,
    });
  }
  chechboxes(item, index) {
    return (
      <li
        class="list-group-item border-0"
        key={"wallcalendaritem-" + index}
        style={{
          backgroundColor: this.props.isMobile ? "transparent" : "white",
        }}
      >
        <span
          className="card-text custom-checkbox ml-4"
          key={"wcitem-" + index}
        >
          <input
            type="checkbox"
            htmlFor={"wcitem-" + index}
            value={item.id}
            checked={item.checked}
            className="custom-control-input"
            id={"wcitem-" + index}
            name={"wcitem-" + index}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            htmlFor={"wcitem-" + index}
            style={{ color: this.props.isMobile ? "white" : null }}
          >
            {item.status}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Wall Calendar</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div className="filter-fields-scroll">
          <ul className="list-group">
            {this.props.filterState.filterData.wallCalendar &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.wallCalendar.map(
                (item, index) => this.chechboxes(item, index)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(WallCalendar);
